<template>
  <el-card shadow="hover"
    style="margin: 15px">
    <div slot="header"
      class="card-header__wrap">
      <span class="card-header--title">未订购</span>
      <div class="card-header--form"></div>
    </div>
    <el-table border
      v-loading="loading"
      :data="list">
      <el-table-column label="增值服务名称"
        prop="vacName">
      </el-table-column>
      <el-table-column label="操作"
        width="240">
        <template slot-scope="{row}">
          <el-button type="text"
            @click="showAddModal(row)"
            size="small">订购</el-button>
        </template>
      </el-table-column>
    </el-table>
    <order-modal ref="modal"
      :vacId="current.vacId"
      :vendorId="current.vendorId"
      :callback="callback" />
  </el-card>
</template>
<script>
import OrderModal from './order-modal.vue'
export default {
  name: 'ordered-table',
  components: { OrderModal },
  props: {
    fetch: [Function]
  },
  data () {
    return {
      loading: false,
      config: {
        pageNum: 1,
        pageSize: 10000
      },
      list: [],
      total: 0,
      current: {}
    }
  },
  methods: {
    fetchList () {
      this.loading = true
      this.$store.dispatch('vacorder/getorderablevacs', {
        payload: {
          ...this.config,
          vendorId: this.$route.query.vendorId
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    showAddModal (row) {
      this.current = {
        vacId: row.vacId,
        vendorId: this.$route.query.vendorId
      }
      this.$refs.modal.toggleModal(true)
    },
    callback () {
      this.fetch && this.fetch()
    }
  },
  mounted () {
    this.fetchList()
  }
}
</script>
<style lang="stylus"></style>
